import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Papa from 'papaparse';
import ImportCsvExcel from '../components/ImportCsv';
import { useSelector } from 'react-redux';
import AdminCreateUser from '../components/AdminCreateUser';
import Filters from '../components/Filters';

const apiPrefix = process.env.REACT_APP_API_PREFIX;


const AdminUsers = () => {
  const token = useSelector((state) => state.user.token);
  const appNumber = useSelector((state) => state.app.appNumber);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(50);
  const [filters, setFilters] = useState([]);

  const columns = [
    { value: 'all', label: 'Tous les champs' },
    { value: 'id', label: 'ID' },
    { value: 'username', label: 'Username' },
    { value: 'firstname', label: 'Prénom' },
    { value: 'lastname', label: 'Nom' },
    { value: 'active', label: 'Actif' },
    { value: 'is_admin', label: 'Admin' },
    { value: 'siret', label: 'Siret' },
    { value: 'chefEntreprise', label: 'Chef d\'Entreprise' },
    { value: 'company', label: 'Company' },
    { value: 'creationDate', label: 'Date de création' },
    { value: 'lastactive', label: 'Dernière activité' },
    { value: 'loginCount', label: 'Connexions' },
  ];

  const handleSelectAllUsers = () => {
    const currentUsers = filterUsers(users, filters).slice(indexOfFirstUser, indexOfLastUser); // ✅ Utilisation correcte
    const currentUsersIds = currentUsers.map(user => user.id);
  
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.length === currentUsersIds.length ? [] : currentUsersIds
    );
  };
  
  

  const handleSelectUser = (id) => {
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.includes(id)
        ? prevSelectedUsers.filter(userId => userId !== id)
        : [...prevSelectedUsers, id]
    );
  };

  const parseDate = (dateString) => {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart ? timePart.split(':').map(Number) : [0, 0, 0];
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  const filterUsers = (users, filters) => {
    return users.filter(user => {
      return filters.every(filter => {
        const { column, value } = filter;
        const term = value.toLowerCase();
  
        if (column === 'all') {
          return Object.values(user).some(field => {
            if (field === null && term === 'null') return true; // Null explicite
            if (typeof field === 'string' && field.toLowerCase().includes(term)) return true;
            if (typeof field === 'number' && field.toString().includes(term)) return true;
            return false;
          });
        }

        if (column === 'loginCount') {
          const operatorMatch = value.match(/^([<>]=?|=)?\s*(\d+)$/); // Match les opérateurs et la valeur
          if (operatorMatch) {
            const [, operator, number] = operatorMatch;
            const numericValue = parseInt(number, 10);
  
            switch (operator) {
              case '>':
                return user.loginCount > numericValue;
              case '>=':
                return user.loginCount >= numericValue;
              case '<':
                return user.loginCount < numericValue;
              case '<=':
                return user.loginCount <= numericValue;
              case '=':
              case undefined: // Pas d'opérateur, correspondance exacte
                return user.loginCount === numericValue;
            }
          } else {
            // Recherche exacte sans opérateurs si aucune correspondance n'est trouvée
            return user.loginCount === parseInt(term, 10);
          }
        }
  
        if (column === 'active') {
          const isActive = user.active ? 'oui' : 'non';
          return isActive.includes(term);
        }
  
        if (column === 'is_admin') {
          const isAdmin = user.is_admin ? 'oui' : 'non';
          return isAdmin.includes(term);
        }

        if (column === 'chefEntreprise') {
          const isChef = user.chefEntreprise ? 'oui' : 'non';
          return isChef.includes(term);
        }
  
        if ((column === 'creationDate' || column === 'lastactive') && user[column]) {
          const userDate = new Date(user[column]);
          const searchDate = parseDate(term);
          return userDate.toLocaleDateString() === searchDate.toLocaleDateString();
        }
  
        const field = user[column];
        if (field === null && term === 'null') return true;
        if (typeof field === 'string' && field.toLowerCase().includes(term)) return true;
        if (typeof field === 'number' && field.toString().includes(term)) return true;
  
        return false;
      });
    });
  };
  

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${apiPrefix}users`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'X-App-Number': appNumber,
          },
        });

        const data = await response.json();
        if (Array.isArray(data)) {
          setUsers(data);
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des utilisateurs :', error);
      }
    };

    fetchUsers();
  }, [appNumber, token]);

  const checkAndUpdateUsers = async (users) => {
    console.log("Début de la vérification et mise à jour des utilisateurs");
  
    for (let user of users) {
      console.log(`Vérification de l'utilisateur ID ${user.id} - SIRET ${user.siret}`);
  
      try {
        const response = await fetch(`https://api.hapluspme.com/v1/3EA50081-D5B9-4DD3-8136-0A94B5DFF39F/adherents/${user.siret}`);
        const data = await response.json();
  
        console.log(`Statut reçu pour l'utilisateur ${user.id} :`, data.status);
  
        if (data.status === 2) {
          console.log(`Mise à jour de l'utilisateur ${user.id} en tant qu'inactif`);
  
          const updateResponse = await fetch(`${apiPrefix}admin/update/${user.id}`, {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
              'X-App-Number': appNumber,  // ✅ Ajout de l'élément appNumber dans la requête
            },
            body: JSON.stringify({
              ...user,
              active: false,
            }),
          });
  
          if (!updateResponse.ok) {
            console.error(`Erreur lors de la mise à jour de l'utilisateur ${user.id}`);
          } else {
            console.log(`Utilisateur ${user.id} mis à jour avec succès`);
          }
        } else {
          console.log(`L'utilisateur ${user.id} est déjà actif, aucune mise à jour nécessaire`);
        }
      } catch (error) {
        console.error(`Erreur lors de la vérification de l'utilisateur ${user.id}:`, error);
      }
    }
  
    console.log("Fin de la vérification et mise à jour des utilisateurs");
  };
  

  const handleDeleteSelectedUsers = async () => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer les utilisateurs sélectionnés ?')) {
      for (let id of selectedUsers) {
        try {
          const response = await fetch(apiPrefix + `users/${id}`, {
            method: 'DELETE',
            headers: {
              'Authorization': `Bearer ${token}`,
              'X-App-Number': appNumber
            },
          });

          if (!response.ok) {
            throw new Error(`Erreur lors de la suppression de l'utilisateur avec l'ID ${id}`);
          }

          setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
        } catch (error) {
          console.error(`Erreur lors de la suppression de l'utilisateur ${id}:`, error);
        }
      }

      setSelectedUsers([]);
    }
  };

  const exportToCsv = () => {
    const csv = Papa.unparse(filterUsers(users, filters));
    const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const csvURL = window.URL.createObjectURL(csvData);
    let tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', 'filtered_users.csv');
    tempLink.click();
  };

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filterUsers(users, filters).slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleCheckAndUpdateUsers = async () => {
    const filteredUsers = filterUsers(users, filters);
  
    await checkAndUpdateUsers(filteredUsers);
  
    // Mise à jour de la liste après le traitement
    try {
      const response = await fetch(`${apiPrefix}users`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'X-App-Number': appNumber,  // ✅ Ajout du header appNumber
        },
      });
  
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des utilisateurs après mise à jour');
      }
  
      const updatedUsers = await response.json();
      setUsers(updatedUsers); // ✅ Met à jour la liste affichée avec les nouveaux statuts
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs après mise à jour :', error);
    }
  };
  

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-theme-primary mb-4">Tous les utilisateurs</h1>
          <p className="text-gray-600 text-lg">Gérez et administrez les comptes utilisateurs</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          <div className="lg:col-span-2 space-y-6">
            <div className="card-theme">
              <h2 className="text-2xl font-bold text-theme-primary mb-4">Actions rapides</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button 
                  onClick={handleCheckAndUpdateUsers}
                  className="btn-theme-secondary"
                >
                  <i className="fas fa-sync-alt mr-2"></i>
                  Vérifier et mettre à jour
                </button>
                <button 
                  onClick={exportToCsv}
                  className="btn-theme-secondary"
                >
                  <i className="fas fa-download mr-2"></i>
                  Exporter en CSV
                </button>
                <button 
                  onClick={handleDeleteSelectedUsers} 
                  disabled={selectedUsers.length === 0}
                  className={`btn-theme w-full sm:col-span-2 ${selectedUsers.length === 0 ? 'opacity-50 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
                >
                  <i className="fas fa-trash mr-2"></i>
                  Supprimer les sélectionnés ({selectedUsers.length})
                </button>
              </div>
            </div>

            <div className="card-theme">
              <h2 className="text-2xl font-bold text-theme-primary mb-4">Import/Export</h2>
              <ImportCsvExcel />
            </div>

            <div className="card-theme">
              <h2 className="text-2xl font-bold text-theme-primary mb-4">Créer un utilisateur</h2>
              <AdminCreateUser />
            </div>
          </div>

          <div className="space-y-6">
            <div className="card-theme">
              <h2 className="text-2xl font-bold text-theme-primary mb-4">Statistiques</h2>
              <div className="bg-theme-primary/5 p-4 rounded-lg">
                <div className="flex items-center">
                  <i className="fas fa-users text-theme-accent text-2xl mr-3"></i>
                  <div>
                    <p className="text-sm text-gray-600">Utilisateurs affichés</p>
                    <p className="text-2xl font-bold text-theme-primary">
                      {filterUsers(users, filters).length}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-theme">
              <h2 className="text-2xl font-bold text-theme-primary mb-4">Filtres</h2>
              <Filters columns={columns} onChange={(newFilters) => setFilters(newFilters)} />
            </div>
          </div>
        </div>

        <div className="card-theme">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 text-theme-accent focus:ring-theme-accent"
                      checked={selectedUsers.length === currentUsers.length && currentUsers.length > 0}
                      onChange={handleSelectAllUsers}
                    />
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Username</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Prénom</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actif</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Admin</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Siret</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date de création</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dernière activité</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Connexions</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Chef d'entreprise</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentUsers.map(user => (
                  <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="checkbox"
                        className="rounded border-gray-300 text-theme-accent focus:ring-theme-accent"
                        checked={selectedUsers.includes(user.id)}
                        onChange={() => handleSelectUser(user.id)}
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-theme-primary">
                      <Link to={`/admin/users/${user.id}`} className="hover:text-theme-accent transition-colors">
                        {user.id}
                      </Link>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      <Link to={`/admin/users/${user.id}`} className="hover:text-theme-accent transition-colors">
                        {user.username}
                      </Link>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.firstname}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.lastname}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        user.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {user.active ? 'Oui' : 'Non'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        user.is_admin ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {user.is_admin ? 'Oui' : 'Non'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.siret || 'N/A'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.company || 'N/A'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {user.creationDate ? new Date(user.creationDate).toLocaleString() : 'Pas de date'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {user.lastactive ? new Date(user.lastactive).toLocaleString() : 'Pas d\'activité'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.loginCount}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        user.chefEntreprise ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {user.chefEntreprise ? 'Oui' : 'Non'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
            <div className="flex-1 flex justify-between sm:hidden">
              <button 
                onClick={() => paginate(currentPage - 1)} 
                disabled={currentPage === 1}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                  currentPage === 1 
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                Précédent
              </button>
              <button 
                onClick={() => paginate(currentPage + 1)} 
                disabled={indexOfLastUser >= users.length}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                  indexOfLastUser >= users.length 
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                Suivant
              </button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <p className="text-sm text-gray-700">
                  Affichage de <span className="font-medium">{indexOfFirstUser + 1}</span> à{' '}
                  <span className="font-medium">{Math.min(indexOfLastUser, users.length)}</span> sur{' '}
                  <span className="font-medium">{users.length}</span> résultats
                </p>
              </div>
              <div>
                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                  <button 
                    onClick={() => paginate(currentPage - 1)} 
                    disabled={currentPage === 1}
                    className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${
                      currentPage === 1 
                        ? 'text-gray-400 cursor-not-allowed' 
                        : 'text-gray-500 hover:bg-gray-50'
                    }`}
                  >
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
                    Page {currentPage}
                  </span>
                  <button 
                    onClick={() => paginate(currentPage + 1)} 
                    disabled={indexOfLastUser >= users.length}
                    className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${
                      indexOfLastUser >= users.length 
                        ? 'text-gray-400 cursor-not-allowed' 
                        : 'text-gray-500 hover:bg-gray-50'
                    }`}
                  >
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;


